import { gql } from '@apollo/client';

export const pickListFragments = {
  pickListItem: gql`
    fragment PickListItem on PickList {
      id
      sequenceNumber
      name
      value
      description
    }
  `,
};

export const SEARCH_PICK_LIST = gql`
  ${pickListFragments.pickListItem}
  query Items($searchInput: SearchInput) {
    searchPickLists(searchInput: $searchInput) {
      items {
        ...PickListItem
      }
    }
  }
`;

export const SAVE_PICK_LIST = gql`
  ${pickListFragments.pickListItem}
  mutation SavePickList($savePickListInput: SavePickListInput!) {
    savePickList(savePickListInput: $savePickListInput) {
      pickList {
        ...PickListItem
      }
      deletedIds
      errors {
        messageKeys
        tag: name
      }
      infos {
        messageKeys
        tag: name
      }
    }
  }
`;
